import React from 'react'
import Markdown from 'react-markdown'

import MessageBubble from './MessageBubble'

type InProgressMessageBubbleProps = { message: string, avatar: React.ReactNode }
const InProgressMessageBubble: React.FC<InProgressMessageBubbleProps> = ({ message, avatar }) => {
  return (
    <MessageBubble avatar={avatar} message={<><Markdown>{message}</Markdown><span className='animate-flicker inline-block bg-deep-green w-1 h-4 ml-1' /></>} />
  )
}

export default InProgressMessageBubble
